import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';
import AssignUserToProjectComponent from './assign-user-to-project.component';


const assignUserToProject = angular.module('ttb.core.popups.userPopup.assignUserToProject', [
  uiBootstrap,
])
  .component('assignUserToProject', AssignUserToProjectComponent)
  .name;

export default assignUserToProject;



// WEBPACK FOOTER //
// ./components/popups/user-popup/assign-user-to-project/index.js